import { RegistryIdentityNameKind, type RegistryIdentityNameListApiResponse } from '@navio/nsdk';
import { URLKeys } from 'noddi-async';
import { type FilterOptionSource } from 'noddi-ui-web';
import { useDebounceValue } from 'noddi-util';
import { useState } from 'react';
import { toFilterOptionSource, useFilterOptionsGet } from '../useFilterOptionsGet';

/**
 * Registry make and model are free text on the car, not catalog rows, so both filters select names rather than
 * ids. The two differ only in the kind they ask for, which is why one hook backs both.
 */
export const useRegistryIdentityNameOptions = (kind: RegistryIdentityNameKind): FilterOptionSource<string> => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounceValue({ value: search, delay: 300 });

  const query = useFilterOptionsGet({
    type: URLKeys.getRegistryIdentityNames,
    input: { pageIndex: 0, pageSize: 200, search: debouncedSearch, kind },
    queryConfig: { select: toNameOptions }
  });

  return toFilterOptionSource(query, 'string', { search, onSearch: setSearch });
};

const toNameOptions = ({ results }: RegistryIdentityNameListApiResponse) =>
  results.map((row) => ({ value: row.name, label: row.name }));
